import React from 'react'
import Typography from '@mui/material/Typography';
import { Grid2 as Grid } from '@mui/material';
import { globalstyles as styles } from '../lib/definitions';


export const common_data_entry = [
    { id: 'name', label: 'Nome (azienda di nascita)', import_id: 'azienda_allevatore' },
    { id: 'cdaua_cowman', label: 'Codice AUA allevatore', import_id: 'cdaua_allevatore' },
    { id: 'regione', label: 'Regione', import_id: 'regione' },
    { id: 'provincia', label: 'Provincia', import_id: 'provincia' },
    { id: 'comune', label: 'Comune', import_id: 'comune' },
]





export const CowmanButton = (props) => {
    const element = props.element
    return (
        <>
            <Typography
                component="div"
                variant="subtitle1"
                color="inherit"
                sx={{
                    color: 'black',
                    fontWeight: 'bold',
                    position: 'relative',
                    fontSize: '12px'
                }}>
                {element.name}
            </Typography>
            <Typography
                component="div"
                variant="subtitle1"
                color="inherit"
                sx={{
                    position: 'relative',
                    fontSize: '11px',
                    textTransform: 'none'
                }}>
                {element.cdaua_cowman}
            </Typography>
        </>
    )

}



export const CowmanRow = (props) => {

    const element = props.element
    const fontSize = props.fontSize || '10px'
    return (
        <Grid container >
            <Grid size={3} sx={{ fontSize: fontSize, color: 'blue' }}>
                {element.cdaua_cowman}
            </Grid>
            <Grid size="grow" sx={{ fontSize: fontSize, fontWeight: 'bold' }}>
                {element.name}
            </Grid>
            <Grid size="auto" sx={{ fontSize: fontSize }}>
            </Grid>

        </Grid>
    )

}
export const CowmanHeader = () => (
    <Grid container >
        <Grid item size={3} sx={styles.listHeader}>
            aua
        </Grid>
        <Grid item size="grow" sx={styles.listHeader}>
            Nome
        </Grid>
        <Grid item size="auto" sx={styles.listHeader}>
            Località
        </Grid>
        <Grid size="grow" sx={styles.listHeader}>
        </Grid>
    </Grid>

)
